
const serverEndpoint = process.env.API_URL;
//console.log(111, process.env, process.env.API_URL)

class App {

    constructor () {
        this.tables = {};
        this.tableOptions = {};
        this.currentUser = null;
        this.processing = false;
        this.serverEndpoint = serverEndpoint;
    }


    async get (e, params, handleError) {
        let endpoint = new URL(serverEndpoint + e);
        if (params) {
            endpoint.search = new URLSearchParams(params).toString();
        }
        return new Promise((resolve, reject) => {
            fetch(endpoint, {
                    method: 'get',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-type': 'application/json'
                    },
                    credentials: 'include',
                })
                .then(async function(response) {
                    if (response.status === 200) {
                        resolve(response.json())
                    } else {
                        if (handleError) handleError(response);
                    }
                })
                .catch((err) => {
                    if (handleError) handleError(err);
                    resolve(false)
                    console.log('err = ', err);
                    //reject(err);
                });
        })
    }

    async post (endpoint, data, headers, handleError) {
        let h = headers;
        if (!h) {
            h = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }
        return new Promise((resolve, reject) => {
            fetch(serverEndpoint + endpoint, {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'include',
                    headers: h,
                    body: data
                })
                .then(async function(response) {
                    if (response.status === 200) {
                        resolve(response.json())
                    } else {
                        if (handleError) handleError(response);
                        resolve(false)
                    }
                })
                .catch(function(err) {
                    if (handleError && err) handleError(err);
                    resolve(false)
                    console.log('err = ', err);
                });
        })
    }

    async remove (endpoint, id, handleError) {
        return new Promise((resolve, reject) => {
            fetch(serverEndpoint + endpoint + id, {
                    method: 'DELETE',
                    mode: 'cors',
                    credentials: 'include',
                })
                .then(async function(response) {
                    if (response.status === 200) {
                        resolve(response.json())
                    } else {
                        if (handleError) handleError(response);
                    }
                })
                .catch(function(err) {
                    console.log('err = ', err);
                    reject(err);
                });
        })
    }

}

var app = new App()
export default app;
